<template lang="pug">
div
  b-icon.ml-2(icon="pencil-square", variant="dark", @click="modal = true")
  b-modal.hide-footer(title="Editar diagnósico" v-model="modal" id="updateDiagnostic")
    div
      div.details.mt-2
        label.font-weight-bold.mr-2 Status
        span {{diagnostic.resultado}}
      div.details.mt-2
        label.font-weight-bold.mr-2 Fecha
        span {{diagnostic.fecha_creacion | formatedDate}}
      div.details.mt-2
        label.font-weight-bold.mr-2 Solución Macro
        span {{diagnostic.solucion_macro? diagnostic.solucion_macro : '-'}}
      div.details.mt-2
        label.font-weight-bold.mr-2 ¿Se pudo replicar la falla?
        b-form-select(v-model="diagnostic.replicar_falla" :options="options")
      div.details.mt-2
        label.font-weight-bold.mr-2 Informe
        b-form-textarea(id="textarea-auto-height", rows="3", max-rows="8", v-model="diagnostic.informe")
      div.details.mt-2
        label.font-weight-bold.mr-2 Solución
        b-button.mb-1(size="sm", variant="outline-primary", :disabled="cargandoIA", @click="sugerirConIA")
          b-spinner.mr-1(v-if="cargandoIA", small)
          span {{ cargandoIA ? 'Generando...' : 'Sugerir con IA' }}
        b-form-textarea(id="textarea-auto-height", rows="3", max-rows="8", v-model="diagnostic.solucion")
    template(#modal-footer='{ ok, cancel, hide }')
      b-button(size='sm' variant='success', @click="editDiagnostic") Editar
      b-button(size='sm' variant='danger', @click="modal = false") Cancelar
</template>
<script>
import { mapActions } from 'vuex'

export default {
  props: ['diagnostic'],
  data() {
    return {
      modal: false,
      cargandoIA: false,
      options: [
        { value: true, text: 'Sí' },
        { value: false, text: 'No' },
      ],
    }
  },
  methods: {
    ...mapActions('Diagnosticos', ['updateDiagnoseOT', 'generarSolucionIA']),
    async sugerirConIA() {
      this.cargandoIA = true
      const response = await this.generarSolucionIA(this.diagnostic.id)
      this.cargandoIA = false
      if (response && response.status === 200) {
        this.diagnostic.solucion = response.data.solucion
      } else {
        const mensaje =
          (response && response.data && response.data.error) ||
          'No se pudo generar la sugerencia'
        this.$bvToast.toast(mensaje, { variant: 'warning' })
      }
    },
    async editDiagnostic() {
      const data = {
        informe: this.diagnostic.informe,
        solucion: this.diagnostic.solucion,
        replicar_falla: this.diagnostic.replicar_falla,
      }
      await this.updateDiagnoseOT({ ...data, id: this.diagnostic.id })
      this.$bvToast.toast('Diagnóstico editado exitósamente', {
        variant: 'success',
      })
      this.modal = false
    },
  },
}
</script>
